






import { Component, Vue } from "vue-property-decorator";
import { IRoute } from "@/@types/routes/routes";
import PagesTabNavigation from "@/components/app/tabs/page-tab-navigation.vue";
@Component({
  name: "Root",
  components: {
    PagesTabNavigation,
  },
})
export default class Root extends Vue {
  routeLinks: string[] = [];

  createRoutes(): void {
    const routes: Array<IRoute> = this.$store.getters.ROUTER_STATE;
    const route = routes.find((el: IRoute) => el.name == this.$options.name);
    if (!routes.length || !route) {
      this.routeLinks.push("WeatherPages");
      return;
    }

    for (const r of route.children) {
      this.routeLinks.push(r);
    }
  }

  mounted(): void {
    this.createRoutes();
  }
}
